export class BasketError extends Error {}
